import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const MudIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Mud - splatter pattern */}
    <ellipse cx="12" cy="16" rx="8" ry="4" />
    <path d="M8 12c-1-2 0-4 0-4" />
    <path d="M12 10c0-3 1-5 1-5" />
    <path d="M16 12c1-2 0-4 0-4" />
    <circle cx="6" cy="9" r="1" />
    <circle cx="18" cy="8" r="1.2" />
    <circle cx="10" cy="6" r="0.8" />
  </svg>
);
